import { BankOutlined } from '@ant-design/icons'
import EditClientPage from '@/features/client/edit-client/page'
import Clients from '@/features/client/page'
import ClientRouteRedirect from '@/pages/clientTabs/ClientRouteRedirect'
import type { ProtectedRouteDescriptor } from '@/routes/types'
import { ClientTypes, permissions, UserTypes } from '@/types/authorization'

function canSeeClientsIndex({
  currentUserTypeId,
  currentClientTypeId,
  defaultClientTypeId,
}: {
  currentUserTypeId?: number
  currentClientTypeId?: number
  defaultClientTypeId?: number
}) {
  const baseClientTypeId = defaultClientTypeId ?? currentClientTypeId

  return (
    currentUserTypeId === UserTypes.Owner ||
    currentUserTypeId === UserTypes.Admin ||
    currentUserTypeId === UserTypes.AdminAdvisor ||
    ((currentUserTypeId === UserTypes.ClientAdmin || currentUserTypeId === UserTypes.ClientUser) &&
      baseClientTypeId === ClientTypes.Advisor)
  )
}

export const clientRouteDescriptors: ProtectedRouteDescriptor[] = [
  {
    key: 'clients',
    path: 'clients',
    element: <Clients />,
    access: { anyOf: [permissions.viewClient, permissions.viewClientChild] },
    visibility: {
      when: (session) => canSeeClientsIndex(session),
    },
    nav: {
      sectionKey: 'manage',
      label: 'Clients',
      Icon: BankOutlined,
      order: 10,
    },
  },
  {
    key: 'client-edit',
    path: 'clients/:clientId/edit',
    element: <EditClientPage />,
    access: { anyOf: [permissions.viewClient, permissions.viewClientChild] },
    visibility: {
      when: (session) => canSeeClientsIndex(session),
    },
  },
  {
    key: 'client-root',
    path: 'clients/:clientId',
    element: <ClientRouteRedirect />,
    access: { anyOf: [permissions.viewClient, permissions.viewClientChild] },
  },
]
